// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__FX6_0","header":"ClearentDisclaimer_header__J83rT","inner":"ClearentDisclaimer_inner__2JY8c"};